export const MIN_ICON_ID = 1
export const MAX_ICON_ID = 184
export const DEFAULT_ICON_ID = 33
export const MEZZO_LIGHTS_ICON_ID = 47
